import React from 'react';
import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import SectionCard from './SectionCard';

export default function NetworkSettingsSection({ form, setField, fillHeight }) {
    return (
        <SectionCard icon="cloud_queue" title="Network Settings" fillHeight={fillHeight}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={form.enableNodeInternetAccess ?? true}
                        onChange={(e) => setField('enableNodeInternetAccess', e.target.checked)}
                        name="enable_node_internet_access"
                        color="primary"
                    />
                }
                label="Enable Node Internet Access"
            />
            <Typography variant="caption" color="textSecondary" display="block" style={{ marginLeft: 32 }}>
                Create NAT Gateway for outbound internet connectivity
            </Typography>
        </SectionCard>
    );
}
